import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

/**
 * JSON-LD service to set SEO chema tags & data
 */
@Injectable({
  providedIn: "root",
})
export class JsonLdService {
  static scriptType = "application/ld+json";

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  removeStructuredData(): void {
    const els = [];
    ["structured-data", "structured-data-org"].forEach((c) => {
      els.push(...Array.from(this._document.head.getElementsByClassName(c)));
    });
    els.forEach((el) => this._document.head.removeChild(el));
  }

  insertSchema(
    schema: Record<string, any>,
    className = "structured-data"
  ): void {
    let script;
    let shouldAppend = false;
    if (this._document.head.getElementsByClassName(className).length) {
      script = this._document.head.getElementsByClassName(className)[0];
    } else {
      script = this._document.createElement("script");
      shouldAppend = true;
    }
    script.setAttribute("class", className);
    script.type = JsonLdService.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this._document.head.appendChild(script);
    }
  }
}
